import { useEffect, useState } from "react";

import { procesarImportaciones } from "../shared/importacionesBot";

/* Los Excel que llegaron al bot, convertidos al abrir Mis planillas
 * (FiboSheets #10).
 *
 * Al montarse atiende las importaciones pendientes del que está logueado
 * (`shared/importacionesBot`) y muestra un aviso por cada una: «Llegó
 * «Costos.xlsx» por WhatsApp: la importé», con lo que pasó con las fórmulas y
 * un botón para abrirla. Si importó alguna, `onImportadas()` le pide a la
 * lista que se recargue.
 *
 * Vive aparte de MiEspacio.jsx para tocar la pantalla grande lo mínimo, y el
 * servicio y SheetJS se cargan recién acá: la lista no paga por algo que casi
 * siempre vuelve vacío. Si la carga o la red fallan, no se muestra nada y la
 * lista sigue igual: lo pendiente queda para la próxima vez.
 */

/* Las dependencias de verdad, cargadas sólo cuando hacen falta. */
async function procesarDeVerdad() {
  // `services/espacio` reexporta el de las importaciones (ver ahí por qué).
  const espacio = await import("../services/espacio");
  return procesarImportaciones({
    svc: espacio,
    crearPlanilla: espacio.crearPlanilla,
    cargarXLSX: () => import("xlsx"),
  });
}

/* Una sola pasada a la vez para toda la pestaña: entrar y salir de una
   planilla (o el doble montaje de React en desarrollo) no arranca otra
   mientras la anterior sigue. El que llega tarde espera la misma. */
let enCurso = null;
function procesarUnaVez(procesar) {
  if (!enCurso) {
    enCurso = Promise.resolve()
      .then(procesar)
      .catch(() => [])
      .finally(() => { enCurso = null; });
  }
  return enCurso;
}

export default function ImportacionesBot({ onImportadas, onAbrir, procesar = procesarDeVerdad }) {
  const [avisos, setAvisos] = useState([]);

  useEffect(() => {
    let vivo = true;
    procesarUnaVez(procesar).then((as) => {
      if (!vivo || !Array.isArray(as) || !as.length) return;
      setAvisos(as);
      if (as.some((a) => a.tipo === "ok") && onImportadas) onImportadas();
    });
    return () => { vivo = false; };
    // Una vez por apertura de la lista: las funciones de arriba no la disparan de nuevo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!avisos.length) return null;
  const cerrar = (id) => setAvisos((as) => as.filter((a) => a.id !== id));

  return (
    <div className="esp-importaciones">
      {avisos.map((a) => (
        <div
          key={a.id}
          className={a.tipo === "ok" ? "panel-aviso suave esp-aviso" : "panel-aviso esp-aviso"}
          role={a.tipo === "ok" ? "note" : "alert"}
        >
          <span>{a.texto}</span>
          {a.tipo === "ok" && a.planillaId && onAbrir && (
            <button className="esp-btn chico" onClick={() => onAbrir(a.planillaId)}>Abrir</button>
          )}
          <button className="esp-btn chico" onClick={() => cerrar(a.id)} aria-label="Cerrar el aviso">×</button>
        </div>
      ))}
    </div>
  );
}
